module.exports = __webpack_public_path__ + "img/ic_prev.550207d3.svg";